import React from 'react';
import {Text} from 'components';

type Props = {
  title: string;
};

export const PrizeTitle: React.FC<Props> = ({title}) => {
  return <Text variant="h1">{title}</Text>;
};
